import { useCompanies, useUsers, useRoles } from '@adsk/alloy-provider';

interface EntityData {
  isLoading: boolean;
  isFound: boolean;
  name?: string;
  property?: string;
  roles?: string[];
  company?: string;
}

export default function useEntityData(userId: string): EntityData {
  const { data: users, loading } = useUsers();
  const { data: companies } = useCompanies();
  const { data: roles } = useRoles();

  const user = users.find((user) => user.autodeskId === userId);
  if (user) {
    const sortedRoleIds: string[] = [];
    const company = companies.find((company) => company.id === user.companyId);
    const userRoleIds = user.roleIds || [];
    if (userRoleIds.length > 0) {
      // user roles come alphabetically sorted
      // we need an array of alphabetically sorted user's roles member groupId
      userRoleIds.forEach((id) => {
        const roleData = roles.find((role) => role.id === id);
        if (roleData) {
          sortedRoleIds.push(roleData.memberGroupId);
        }
      });
    }
    return {
      name: user.name,
      isFound: true,
      property: company ? company.name : undefined,
      company: company ? company.memberGroupId : undefined,
      roles: sortedRoleIds,
      isLoading: false,
    };
  }
  const company = companies.find((company) => company.memberGroupId === userId);

  if (company) {
    return {
      name: company.name,
      isFound: true,
      property: undefined,
      isLoading: false,
    };
  }
  const role = roles.find((role) => role.memberGroupId === userId);
  if (role) {
    return {
      name: role.name,
      isFound: true,
      property: undefined,
      isLoading: false,
    };
  }
  return {
    isLoading: loading,
    isFound: false,
  };
}
